"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Determines if all the passed args are strings
 * @param args The arguments to check
 */
function isString() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.every(function (arg) { return typeof arg === 'string'; });
}
exports.isString = isString;
/**
 * Determines if all the passed args are numbers
 * @param args The arguments to check
 */
function isNumber() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.every(function (arg) { return typeof arg === 'number'; });
}
exports.isNumber = isNumber;
